import React from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";

import ControlSessionModal from "./ControlSessionModal";
import processStates from "@common/constants/processStates";
import processTypes from "@common/constants/processTypes";
import { MACH_STATES } from "@common/constants/sessionConstants";
import * as sessionService from "@brewery/services/sessionService";
import "./control-session.scss";

class ControlSession extends React.Component {
  state = {
    showModal: false,
    pauseLoading: false,
  };

  openModal = () => {
    this.setState({ showModal: true });
  };

  handlePauseResume = () => {
    const { currentLog, session } = this.props;
    const isPaused =
      currentLog &&
      currentLog.currentStatus.machState === MACH_STATES.MACH_STATE_PAUSED;

    this.setState({ pauseLoading: true });
    const command = isPaused
      ? sessionService.updateSession(session.id, { command_type: 3 })
      : sessionService.updateSession(session.id, { command_type: 2 });

    command.finally(() => this.setState({ pauseLoading: false }));
  };

  render() {
    const { showModal, pauseLoading } = this.state;
    const { currentLog } = this.props;

    const isPaused =
      currentLog &&
      currentLog.currentStatus.machState === MACH_STATES.MACH_STATE_PAUSED;

    const disableStop =
      currentLog &&
      currentLog.currentStatus.procType === processTypes.PROC_SERVING &&
      currentLog.currentStatus.procState !==
        processStates.SERVING_TEMP_CONTROL_STATE;

    const kegNeedsCleaning =
      currentLog &&
      currentLog.currentStatus.procState ===
        processStates.SERVING_TEMP_CONTROL_STATE;

    return (
      <div style={{ display: "flex", gap: "8px" }}>
        <Button
          className="control-session__button"
          onClick={this.handlePauseResume}
          disabled={pauseLoading}
          style={{
            backgroundColor: isPaused ? "#388e3c" : "#1565c0",
            borderColor: isPaused ? "#388e3c" : "#1565c0",
            color: "white",
          }}
        >
          {pauseLoading ? "..." : isPaused ? "RESUME" : "PAUSE"}
        </Button>
        <Button
          className="control-session__button"
          onClick={this.openModal}
          disabled={disableStop}
          style={{
            backgroundColor: "#e53935",
            borderColor: "#e53935",
            color: "white",
          }}
        >
          STOP
        </Button>
        <ControlSessionModal
          show={showModal}
          sessionID={this.props.session.id}
          handleClose={() => this.setState({ showModal: false })}
          kegNeedsCleaning={kegNeedsCleaning}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ mqtt }) => {
  return { mqtt };
};

export default connect(mapStateToProps, null)(ControlSession);
